export enum DOMAIN_PAGE_NAME {
  VISIT_PAGE = "visit_page",
  PLAN_OF_CARE = "plan_of_care",
  ASSESSMENT_SECTION = "assessment_section",
  PATIENT_REFERRAL_PAGE = "patient_referral_page",
  IDG_PAGE = "idg_page",
  DOCUMENT_MANAGEMENT = "doc_management",
  APP_NAVIGATION_MENU = "app_navigation_menu",
  PATIENT_CHART_PAGE = "patient_patient_chart_page",
  CALENDER_PAGE = "calendar_page",
  VOLUNTEER_MANAGEMENT_PAGE = "volunteer_management_page",
  ORDER_MANAGEMENT_PAGE = "Patient_OrderManagement_Clinical_Admin",
  COMMUNITY_BEREAVED = "Community_Bereaved",
  RESOURCE_MANAGEMENT = "resource_management",
  BILLING = "billing",
  BILLING_SECTION = "billing_section",
  CTI = "cti_page",
}

export enum PAGES {
  VISIT_PAGE = 123,
  PLAN_OF_CARE = 123,
  ASSESSMENT_SECTION = 123,
  PATIENT_REFERRAL_PAGE = 19,
  DOCUMENT_MANAGEMENT = 123,
  APP_NAVIGATION_MENU = 123,
  PATIENT_CHART_PAGE = 27,
  CALENDER_PAGE = 489,
  COMMUNITY_BEREAVED = 500,
  RESOURCE_MANAGEMENT_PROVIDERS = 1001,
  RESOURCE_MANAGEMENT_NON_PROVIDER_CLINICIANS = 1002,
  RESOURCE_MANAGEMENT_VOLUNTEERS = 1003,
  RESOURCE_MANAGEMENT_BACK_OFFICE = 1004,
}

export enum PAGE_RESOURCES {
  VISIT_PAGE_VISIT_ADD_BTN = 134,
  VISIT_PAGE_VISIT_EDIT_BTN = 410,
  VISIT_PAGE_FREQUENCY_ADD_BTN = 905,
  VISIT_PAGE_FREQUENCY_EDIT_BTN = 905,
  VISIT_PAGE_FREQUENCY_DELETE_BTN = 905,
  DOCUMENT_MANAGEMENT_ADD_BTN = 134,

  SCHEDULER_PAGE_RESOURCES_DROPDOWN = 411,

  COMPANY_MAINMENU = 111,
  BILLING_MAINMENU = 222,
  PATIENT_MAINMENU = 333,
  COMPLIANCE_MAINMENU = 444,
  REPORTS_MAINMENU = 555,
  PROVIDERS_MAINMENU = 666,
  HELP_MAINMENU = 777,

  REFERRAL_PAGE_ADD_PATIENT = 19,
  REFERRAL_PAGE_ADMIT_PATIENT = 289,
  Patient_AddPatient_CallerReferrerTab = 20,
  Patient_AddPatient_InitialCertificationTab = 25,
  PATIENT_ADD_PATIENT_PATIENT_TAB = 21,
  PATIENT_ADD_PATIENT_CLINICAL_Tab = 23,

  // PATIENT_CHART_PAGE_RESOURCES
  PATIENT_CHART_NOTES_ADD_COMMUNICATION_BUTTON = 147,
  PATIENT_CHART_CERTIFICATION_ADD_CERTIFICATE = 148,
  PATIENT_CHART_DIAGNOSIS_CHANGE_DIAGNOSIS = 128,
  PATIENT_CHART_DIAGNOSIS_HISTORY_TAB = 129,

  PATIENT_CHART_REPORTS_TAB = 37,
  PATIENT_CHART_CARETEAM_TAB = 34,
  PATIENT_CHART_ACTIVITY_TAB = 33,
  PATIENT_CHART_CAREPLAN_TAB = 72,
  PATIENT_CHART_DOCUMENTS_TAB = 395,
  PATIENT_CHART_MEDS_DME_TAB = 124,
  PATIENT_CHART_NOTES_TAB = 125,
  PATIENT_CHART_PROFILE_CHANGE_LEVEL_OF_CARE = 126,
  PATIENT_CHART_PROFILE_TAB_HISTORY = 127,
  PATIENT_CHART_DIAGNOSIS_TAB_CHANGE_DIAGNOSIS = 128,
  PATIENT_CHART_DIAGNOSIS_TAB_DIAGNOSIS_HISTORY = 129,

  PATIENT_CHART_PROFILE_TAB_PATIENT_DETAIL_TAB = 29,
  PATIENT_CHART_PROFILE_TAB_LEVELOFCARE_TAB = 30,
  PATIENT_CHART_PROFILE_TAB_DIAGNOSIS_TAB = 31,

  PATIENT_CHART_STATUS_CHANGE_STATUS = 130,
  PATIENT_CHART_STATUS_TAB_HISTORY = 131,
  PATIENT_CHART_PROFILE_TAB_STATUS_TAB = 32,

  PATIENT_CHART_PLAN_OF_CARE_BUTTON = 359,
  PATIENT_CHART_REPORTS_HIS_GENERATE_HIS_REPORT = 146,
  PATIENT_CHART_PATIENT_CHART = 27,
  PATIENT_CHART_PROFILE_TAB = 28,
  PATIENT_CHART_CLAIMS_TAB = 42,
  PATIENT_CHART_IDG = 276,
  PATIENT_ADD_PATIENT_BENEFITS_TAB = 24,
  PATIENT_ADD_PATIENT_CONSENTS_TAB = 26,
  PATIENT_PATIENT_CHART_BENEFITES_TAB = 41,
  PATIENT_CHART_PROFILE_TAB_PHYSICIAN_EDIT = 396,
  PATIENT_PATIENTCHART_BEREAVEMENTTAB = 404,
  Company_User_Calendar_ViewAllTasks_Unscheduled_Tab = 402,
  Company_User_Calendar_AddVisit = 409,
  Company_VolunteerActivityAdministrator = 406,
  Company_VolunteerActivityVolunteer = 407,
  Providers_Personnel = 162,
  Providers_Facilities = 163,
  Patient_OrderManagement_Clinical_Admin = 408,
  BILLING_MAIN_MENU = 2000,
  BILLING_CLAIM_MANAGEMENT = 2001,
  BILLING_PAYMENT_MANAGEMENT = 2002,
  PATIENT_CHART_CERTIFICATION_WRITTEN = 412,
  PATIENT_CHART_CERTIFICATION_VERBAL = 413,
}

export enum ACCESS_LEVEL {
  NONE = 0,
  READ = 1,
  WRITE = 2,
}



// WEBPACK FOOTER //
// ./src/app/access-control/access-control-constant.ts